import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IMainMccField {
	changeMainMccCardMcc: (value: Nullable<number>) => void;
}

const MainMccField: React.FC<IMainMccField> = ({ changeMainMccCardMcc }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(
		() => [
			({ getFieldValue }) => ({
				validator(_, value) {
					if (getFieldValue('mainMccCardBrand') && !value) {
						return Promise.reject(new Error(t('enterMcc')));
					}
					return Promise.resolve();
				},
			}),
		],
		[t],
	);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			changeMainMccCardMcc(value);
		},
		[changeMainMccCardMcc],
	);

	return (
		<FormInput
			testId="MainMccField"
			type="number"
			min={1000}
			max={9999}
			name="mainMccCardMcc"
			label="mccLabel"
			onChangeNumber={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(MainMccField);
